import { SkyMapTheme } from '../../styled-component-theme';

/**
 *  No set structure. Just an example.
 */
export const defaultTheme: SkyMapTheme = {
  color: {
    brand: {
      dark: '#fed530',
      medium: '#feed99',
      light: '#fff1ae',
      lightest: '#fff8d5',
    },
    gray: {
      darkest: '#37424a',
      dark: '#5e6a71',
      medium: '#a5acaf',
      light: '#d1d4d3',
      lightest: '#eee',
    },
    red: '#db4d69',
    blue: '#00a9e0',
    green: '#00ad83',
    text: '#888',
    selected: '#d0e4f7',
  },
  font: {
    'font-family': `'Montserrat', sans-serif`,
  },
};
